import { useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';

import { activePanelState, completePanelState, Panel, PanelStatus, resetPanelState } from '@foradevelopment/fora-ui';
import { EmploymentViewModelNew } from '@fora-monorepo/employer-my-pages-common/types';
import { manageWorkersMatomo, matomoTracking } from '@fora-monorepo/webapp-analytics';

import { EmployerMyPagesErrorPage, layoutSizeSettings } from '../../components';
import { useAppSelector } from '../../redux/hooks';
import { links } from '../../router/links';
import { EditEmploymentPeriodConfirmationPanel } from '../panels/EditEmploymentPeriod/EditEmploymentPeriodConfirmationPanel';
import { EditEmploymentPeriodPanel } from '../panels/EditEmploymentPeriod/EditEmploymentPeriodPanel';
import { EditEmploymentPeriodParams } from '../../router/paths';

export const EditEmploymentPeriodView = () => {
  const { policyNumber, employmentPeriodIndex } = useParams<EditEmploymentPeriodParams>();

  const employments = useAppSelector(state => state.employment.employmentsNew);
  const employment = useMemo(() => employments.find(e => e.policyNumber === policyNumber), [employments, policyNumber]);
  const [panelStates, setPanelStates] = useState({ form: activePanelState(), confirmation: resetPanelState() });

  const employmentPeriod = useMemo(() => {
    const i = Number(employmentPeriodIndex);
    if (!employment?.employmentPeriods || i >= employment.employmentPeriods.length) {
      return null;
    }
    return employment.employmentPeriods[i];
  }, [employment, employmentPeriodIndex]);

  useEffect(() => {
    if (panelStates.form.status === PanelStatus.Active) {
      matomoTracking(manageWorkersMatomo, 'ändra');
    }
    if (panelStates.confirmation.status === PanelStatus.Active) {
      matomoTracking(manageWorkersMatomo, 'bekräftelse');
    }
  }, [panelStates.form.status, panelStates.confirmation.status]);

  const [confirmationEmployment, setConfirmationEmployment] = useState<EmploymentViewModelNew | undefined>();

  const goToEditConfirmationPanel = (employment: EmploymentViewModelNew) => {
    setPanelStates({ form: completePanelState(), confirmation: activePanelState() });
    setConfirmationEmployment(employment);
  };

  const goToEditEmploymentPeriodPanel = () => {
    setPanelStates({ form: activePanelState(), confirmation: resetPanelState() });
  };

  if (!policyNumber || !employment || !employmentPeriodIndex || !employmentPeriod) {
    return <EmployerMyPagesErrorPage type={404} startPageLinkUrl={links.employments} />;
  }

  return (
    <Panel.List
      paddingLeft={0}
      paddingRight={0}
      marginLeft={layoutSizeSettings.removePadding}
      marginRight={layoutSizeSettings.removePadding}
    >
      <EditEmploymentPeriodPanel
        panelState={panelStates.form}
        employment={employment}
        goToNextPanel={goToEditConfirmationPanel}
        employmentPeriodIndex={Number(employmentPeriodIndex)}
      />
      <EditEmploymentPeriodConfirmationPanel
        panelState={panelStates.confirmation}
        goBackToEditPanel={goToEditEmploymentPeriodPanel}
        employment={confirmationEmployment}
        employmentPeriodIndex={Number(employmentPeriodIndex)}
      />
    </Panel.List>
  );
};
